import { makeStyles } from '@material-ui/core';

import palette from '../../theme/palette';

export default makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    height: '100%',
    background: palette.backgrounds.dark,
    [theme.breakpoints.down('sm')]: {
      height: '100%'
    }
  },
  container: {
    paddingTop: theme.spacing(10)
  },
  toolbar: {
    display: 'flex',
    padding: theme.spacing(1),
    justifyContent: 'space-between',
    gap: theme.spacing(2)
  },
  toolbarActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5)
  },
  button: {
    backgroundColor: palette.buttons.purple,
    color: palette.white,
    width: theme.spacing(25),
    fontWeight: 'bold',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(6),
    '&:disabled': {
      backgroundColor: palette.common.grayAvatar,
      color: palette.white
    },
    '&:hover': {
      backgroundColor: palette.primary.lighter
    }
  },
  heading: {
    marginTop: theme.spacing(0.5),
    color: palette.white,
    fontSize: theme.spacing(3),
    fontWeight: 'bold',
    fontFamily: 'Roboto'
  },
  heading2: {
    color: palette.white,
    fontWeight: 'bold',
    fontFamily: 'Roboto'
  },
  reviewBox: {
    minHeight: '75vh',
    height: '100%',
    width: '100%',
    background: palette.backgrounds.light,
    borderRadius: theme.spacing(1.5)
  },
  searchRow: {
    display: 'flex',
    padding: theme.spacing(1),
    justifyContent: 'space-between',
    gap: theme.spacing(1)
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1)
  },
  formActions: {
    display: 'flex',
    padding: theme.spacing(1),
    gap: theme.spacing(0.5)
  },
  details: {
    minHeight: '65vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(1)
  },
  label: {
    marginTop: theme.spacing(1),
    fontSize: theme.spacing(2),
    color: palette.review.label,
    fontWeight: 'bold',
    [theme.breakpoints.down('xl')]: {
      fontSize: theme.spacing(2.5)
    }
  },
  detailValue: {
    color: '#6f7594',
    fontSize: theme.spacing(1.5),
    [theme.breakpoints.down('xl')]: {
      fontSize: theme.spacing(2)
    }
  },
  textAreaField: {
    width: '100%',
    color: palette.white,
    background: palette.backgrounds.dark,
    borderRadius: theme.spacing(1.5),
    flexShrink: 0,
    [theme.breakpoints.down('xl')]: {
      fontSize: theme.spacing(2)
    }
  },
  dropdownContainer: {
    marginTop: theme.spacing(0.5),
    height: theme.spacing(4),
    width: '100%',
    padding: theme.spacing(1),
    color: palette.white,
    background: palette.backgrounds.dark,
    borderRadius: theme.spacing(1)
  },
  icon: {
    color: palette.white
  },
  dropdownText: {
    color: palette.adminHome.primaryBlack,
    fontWeight: 'bold'
  },
  showDropdown: {
    display: 'block',
    color: palette.white
  },
  hideDropdown: {
    display: 'none'
  },
  dropdownList: {
    marginTop: theme.spacing(-1),
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(1),
    padding: 0,
    color: palette.white,
    backgroundColor: palette.white,
    borderRadius: theme.spacing(2),
    listStyle: 'none'
  },
  dropdownItem: {
    display: 'flex',
    justifyContent: 'space-between',
    color: palette.common.primaryGray,
    fontWeight: 'bold'
  },
  pdfContainer: {
    height: '100%',
    width: '100%',
    borderRadius: theme.spacing(1.5),
    background: palette.backgrounds.light,
    [theme.breakpoints.down('sm')]: {
      minHeight: '80vh'
    }
  },
  iframe: {
    border: 0
  },
  noPdf: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  notAvailable: {
    color: palette.white,
    fontSize: theme.spacing(3),
    fontWeight: 'bold'
  },
  dialog: {
    background: palette.white
  },
  confirm: {
    background: palette.buttons.purple,
    color: palette.white,
    fontWeight: 'bold',
    borderRadius: theme.spacing(6),
    '&:hover': {
      background: palette.primary.lighter
    }
  }
}));
